import { Container } from "reactstrap";
import { PurchaseHeader } from "../../components/Headers/Headers";
import CreatePurchaseOrder from "../../components/modals/CreatePurchaseOrder";
import PageName from "../../components/react_helmet/PageName";
import PurchaseOrderTable from "../../components/table/PurchaseOrderTable";
import usePurchaseOrders from "./customHooks/usePurchaseOrders";
import TableSkeleton from "../../components/skeleton/TableSkeleton";
const PurchaseOrders = () => {
  const {
    searchValue,
    setSearchValue,
    purchaseOrders,
    setSelectedItem,
    selectedData,
    setSelectedData,
    selectedItem,
    user,
    createOrder,
    setCreateOrder,
    page,
    setPage,
    pageSize,
    setPageSize,
    loading,
    totalPages,
    setShipping,
    setVendorData,
    selectedOrdersIds, setSelectedOrdersIds,
    handleShippingData,
    all_vendors, gettingPos
  } = usePurchaseOrders();
  return (
    <>
      <PageName title={"Purchase Orders"} />
      <CreatePurchaseOrder
        selectedOrdersIds={selectedOrdersIds}
        setSelectedOrdersIds={setSelectedOrdersIds}
        handleShippingData={handleShippingData}
        directPO={true}
        setVendorData={setVendorData}
        setShipping={setShipping}
        all_vendors={all_vendors}
        modal={createOrder}
        gettingPos={gettingPos}
        toggle={() => {
          setCreateOrder((prev) => !prev);
        }}
      />
      <Container fluid className="">
        <PurchaseHeader
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          setSelectedItem={setSelectedItem}
          selectedItem={selectedItem}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          data={purchaseOrders}
          loading={loading}
          setPage={setPage}
          user={user}
          totalPages={totalPages}
          toggle={() => {
            setCreateOrder((prev) => !prev);
          }}
          gettingPos={gettingPos}
        />
        <div className="settings-card mt-3">
          {loading ? (
            <TableSkeleton columns={8} />
          ) : (
            <PurchaseOrderTable
              data={purchaseOrders}
              setSelectedData={setSelectedData}
              user={user}
              searchValue={searchValue}
              setSelectedItem={setSelectedItem}
              page={page}
              totalPages={totalPages}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              onClearSearch={searchValue ? () => {
                setSearchValue("");
                setPage(1);
              } : undefined}
            />
          )}
        </div>
      </Container>
    </>
  );
};
export default PurchaseOrders;
